import React from 'react';
import classNames from 'classnames';

import './index.scss';

export default function Collapsable({collapsed, height, children}) {
    return (
        <div
            className={classNames('collapsable', {'collapsable--collapsed': collapsed})}
            style={{height: collapsed ? 0 : height}}
        >
            {children}
        </div>
    );
}



// WEBPACK FOOTER //
// ./components/collapsable/index.js